"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ui = require("@unite-us/ui");
function isAddressValid() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    state = _ref.state,
    city = _ref.city,
    required = _ref.required;
  var stateValue = (0, _ui.getPreferredProp)(state, 'value');
  var cityValue = (0, _ui.getPreferredProp)(city, 'value');
  var isEmpty = !stateValue;
  var hasEnoughInfo = !!cityValue;
  return hasEnoughInfo || isEmpty && !required;
}
var _default = exports["default"] = isAddressValid;